<template>
    <div class="emp-card" :class="{ 'ctr-split': isStandalone }" :key="`emp-${employeeId}`">
        <div class="ctr-gridcol">
        <div v-if="isStandalone" class="ctr-col-head"><i class="dx-icon dx-icon-toolbox"></i> Contracte</div>
        <DxDataGrid :data-source="dsContracteMunca" ref="dataGridRef" width="100%"
            :allow-column-reordering="true" :allow-column-resizing="true" :column-auto-width="false"
            column-resizing-mode="widget" :show-borders="true" key-expr="Id"
            :show-column-lines="false" :show-row-lines="true" :row-alternation-enabled="true"
            :hover-state-enabled="true" class="ctr-grid" @row-dbl-click="onRowDblClick"
            @selection-changed="onContractSelected">
            <DxStateStoring :enabled="!isStandalone" type="localStorage" storage-key="grid-contracte-munca-state" />
            <DxSelection mode="single" />
            <DxFilterRow :visible="false" />
            <DxPaging :page-size="10" :page-index="0" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxScrolling mode="virtual" column-rendering-mode="virtual" :show-scrollbar="'always'" />
            <DxColumnFixing :enabled="true" />
            <DxColumnChooser :enabled="true" mode="select" />
            <DxEditing :allow-updating="!isStandalone" mode="popup">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="700" :height="450"
                    :show-title="false">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="saveButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
            </DxEditing>
            <DxColumn data-field="NumarContract" width="120" caption="Nr. contract" />
            <DxColumn data-field="StareCurenta" :width="isStandalone ? undefined : 160" caption="Stare" cell-template="stareTpl" />
            <DxColumn data-field="TransferInRevisal" width="120" caption="Revisal" cell-template="revisalTpl" :visible="!isStandalone" />
            <template #stareTpl="{ data }">
                <span class="ctr-chip" :class="stareClass(data.value)">{{ stareLabel(data.value) }}</span>
            </template>
            <template #revisalTpl="{ data }">
                <i v-if="data.value" class="dx-icon dx-icon-check" style="color:#059669;font-weight:bold"></i>
                <span v-else style="color:#cbd5e1">—</span>
            </template>
            <DxColumn data-field="CorId" width="220" caption="COR Cod" :visible="!isStandalone">
                <DxLookup :data-source="dsCor" value-expr="Id" :display-expr="corDisplayExpr" :search-enabled="true" />
            </DxColumn>
            <DxColumn data-field="CorVersiune" width="110" caption="COR Versiune" :visible="!isStandalone" />
            <DxColumn data-field="DataConsemnare" width="130" format="dd.MM.yyyy" data-type="date" :visible="!isStandalone" />
            <DxColumn data-field="DataIncepereActivitate" :width="isStandalone ? undefined : 140" caption="Data" format="dd.MM.yyyy" data-type="date" />
            <DxColumn data-field="DataIncheiereContract" width="140" format="dd.MM.yyyy" data-type="date" :visible="!isStandalone" />
            <DxColumn data-field="SalariuBrut" width="100" :visible="!isStandalone" />
            <DxColumn data-field="SporTipNume" width="100" :visible="!isStandalone" />
            <DxColumn data-field="TimpMuncaNorma" width="100" :visible="!isStandalone" />
            <DxColumn data-field="TimpMuncaRepartizare" width="100" :visible="!isStandalone" />
            <DxColumn data-field="TimpMuncaDurata" width="100" :visible="!isStandalone" />
            <DxColumn data-field="TipContract" width="100" :visible="!isStandalone" />
            <DxColumn data-field="TipNorma" width="100" :visible="!isStandalone" />
            <DxColumn data-field="Radiat" width="100" :visible="!isStandalone" />
            <!-- coloane ascunse implicit: goale/rare in DB sau interne (accesibile din column chooser) -->
            <DxColumn data-field="DataCreare" width="100" :visible="false" format="dd.MM.yyyy" data-type="date" />
            <DxColumn data-field="DateContractVechi" width="140" :visible="false" />
            <DxColumn data-field="Detalii" width="100" :visible="false" />
            <DxColumn data-field="AngajatorSursaCui" width="100" :visible="false" />
            <DxColumn data-field="AngajatorSursaDenumire" width="100" :visible="false" />
            <DxColumn data-field="DataImport" width="100" :visible="false" format="dd.MM.yyyy" data-type="date" />
            <DxColumn data-field="TipMutare" width="100" :visible="false" />
            <DxColumn data-field="ExceptieDataSfarsit" width="100" :visible="false" format="dd.MM.yyyy" data-type="date" />
            <DxColumn data-field="NumereContractVechi" width="100" :visible="false" />
            <DxColumn data-field="TimpMuncaIntervalTimp" width="100" :visible="false" />
            <DxColumn data-field="DataReactivare" width="100" :visible="false" format="dd.MM.yyyy" data-type="date" />
            <DxColumn data-field="EchipamentIndividualProtectie" width="100" :visible="false" />
            <DxColumn data-field="EchipamentIndividualLucru" width="100" :visible="false" />
            <DxColumn data-field="MaterialeIgienicoSanitare" width="100" :visible="false" />
            <DxColumn data-field="AlimentatieProtectie" width="100" :visible="false" />
            <DxColumn data-field="AlteDrepturiObligatiiSsm" width="100" :visible="false" />
            <DxColumn data-field="NumarContractColectivMunca" width="100" :visible="false" />
            <DxColumn data-field="DataIncheiereContractColectiv" width="100" :visible="false" format="dd.MM.yyyy" data-type="date" />
            <DxColumn data-field="SeriePermisMunca" width="100" :visible="false" />
            <DxColumn data-field="NumarPermisMunca" width="100" :visible="false" />
            <DxColumn data-field="DataPermisMunca" width="100" :visible="false" format="dd.MM.yyyy" data-type="date" />
            <DxColumn data-field="LocatiaDesfasurariiActivitatii" width="100" :visible="false" />
            <DxColumn data-field="NrLuniActivitate" width="100" :visible="false" />
            <DxColumn data-field="ConcediuOdihnaSuplimentar" width="100" :visible="false" />
            <DxColumn data-field="DataPlataSalariu" width="100" :visible="false" format="dd.MM.yyyy" data-type="date" />
            <DxColumn data-field="PerioadaProba" width="100" :visible="false" />
            <DxColumn data-field="TipPreaviz" width="100" :visible="false" />
            <DxColumn data-field="PerioadaPreaviz" width="100" :visible="false" />
            <DxToolbar>
                <!-- Butonul "Vezi pagina de contracte" – DOAR când nu e ruta Contracte -->
                <DxItem location="before" v-if="$route.name !== 'Contracte'">
                    <template #default>
                        <button class="continue-application" @click="goToContracts">
                            <div>
                                <div class="folder">
                                    <div class="top">
                                        <svg viewBox="0 0 24 27">
                                            <path d="M0 0h24v27H0z"></path>
                                        </svg>
                                    </div>
                                    <div class="paper"></div>
                                </div>
                                <div class="pencil"></div>
                            </div>
                            Vezi pagina de contracte
                        </button>
                    </template>
                </DxItem>
                
                <DxItem location="before" v-if="$route.name == 'Contracte'">
                    <template #default>
                        <DxButton text="Înapoi" icon="arrowleft"  type="default"
                            class="back-button" @click="goBack" />
                    </template>
                </DxItem>
                <DxItem location="before" v-if="!isStandalone">
                    <template #default>
                        <div class="ctr-actions">
                            <DxButton icon="edit" hint="Corecție" styling-mode="outlined" class="ctr-act"
                                @click="onSubAction('corectie')" />
                            <DxButton icon="clock" hint="Suspendare" styling-mode="outlined" class="ctr-act"
                                @click="onSubAction('suspendare')" />
                            <DxButton icon="export" hint="Detașare" styling-mode="outlined" class="ctr-act"
                                @click="onSubAction('detasare')" />
                            <DxButton icon="home" hint="Schimbare loc muncă" styling-mode="outlined" class="ctr-act"
                                @click="onSubAction('schimbLocMunca')" />
                            <DxButton icon="close" hint="Încetare/Reactivare" styling-mode="outlined" class="ctr-act"
                                @click="onSubAction('incetareReactivare')" />
                            <DxButton icon="bulletlist" hint="Istoric" styling-mode="outlined" class="ctr-act"
                                @click="onSubAction('istoric')" />
                            <DxButton icon="doc" hint="L153" styling-mode="outlined" class="ctr-act"
                                @click="onSubAction('l153')" />
                        </div>
                    </template>
                </DxItem>

                <DxItem location="after" v-if="!isStandalone">
                    <template #default>
                        <DxButton icon="add" text="Adaugă contract" type="success" styling-mode="contained"
                            @click="onAddClick" />
                    </template>
                </DxItem>

            </DxToolbar>
        </DxDataGrid>
        </div>

        <!-- Coloana dreapta: formular editare/adaugare (doar pe pagina standalone) -->
        <div v-if="isStandalone" class="ctr-formcol">
            <div class="ctr-form-toolbar">
                <DxButton icon="edit" text="Corecție" styling-mode="outlined" class="ctr-act" @click="onSubAction('corectie')" />
                <DxButton icon="clock" text="Suspendare" styling-mode="outlined" class="ctr-act" @click="onSubAction('suspendare')" />
                <DxButton icon="export" text="Detașare" styling-mode="outlined" class="ctr-act" @click="onSubAction('detasare')" />
                <DxButton icon="home" text="Schimb. loc muncă" styling-mode="outlined" class="ctr-act" @click="onSubAction('schimbLocMunca')" />
                <DxButton icon="close" text="Încetare/Reactivare" styling-mode="outlined" class="ctr-act" @click="onSubAction('incetareReactivare')" />
                <DxButton icon="bulletlist" text="Istoric" styling-mode="outlined" class="ctr-act" @click="onSubAction('istoric')" />
                <DxButton icon="doc" text="L153" styling-mode="outlined" class="ctr-act" @click="onSubAction('l153')" />
                <DxButton icon="add" text="Adaugă contract" type="success" styling-mode="contained"
                    class="ctr-add-btn" @click="addNouContract" />
            </div>
            <div class="ctr-form-head" :class="{ 'is-new': editIsNew }">
                <i class="dx-icon" :class="editIsNew ? 'dx-icon-add' : 'dx-icon-edit'"></i>
                <span>{{ editIsNew ? 'Contract nou' : (editForm.NumarContract ? ('Contract ' + editForm.NumarContract) : 'Selectează un contract') }}</span>
                <span v-if="!editIsNew && editForm.StareCurenta" class="ctr-chip" :class="stareClass(editForm.StareCurenta)" style="margin-left:auto">{{ stareLabel(editForm.StareCurenta) }}</span>
            </div>
            <div v-if="editForm.Id || editIsNew" class="ctr-form-body">
                <div class="ctr-seclbl">Date contract</div>
                <div class="ctr-g3">
                    <div class="ff"><label>Număr contract</label><DxTextBox v-model:value="editForm.NumarContract" /></div>
                    <div class="ff"><label>Tip contract</label>
                        <DxSelectBox :data-source="dsTipContract" value-expr="Cod" display-expr="Nume"
                            v-model:value="editForm.TipContract" :search-enabled="true" :show-clear-button="true" />
                    </div>
                    <div class="ff"><label>Tip normă</label>
                        <DxSelectBox :data-source="dsTipNorma" value-expr="Cod" display-expr="Nume"
                            v-model:value="editForm.TipNorma" :search-enabled="true" :show-clear-button="true" />
                    </div>
                    <div class="ff full"><label>Funcție (COR)</label>
                        <DxSelectBox :data-source="dsCor" value-expr="Id" :display-expr="corDisplayExpr"
                            v-model:value="editForm.CorId" :search-enabled="true" :show-clear-button="true" />
                    </div>
                    <div class="ff"><label>Transfer în Revisal</label><DxCheckBox v-model:value="editForm.TransferInRevisal" /></div>
                </div>

                <hr class="ctr-fline">
                <div class="ctr-seclbl">Perioade</div>
                <div class="ctr-g3">
                    <div class="ff"><label>Consemnare</label><DxDateBox v-model:value="editForm.DataConsemnare" type="date" display-format="dd.MM.yyyy" /></div>
                    <div class="ff"><label>Data CIM</label><DxDateBox v-model:value="editForm.DataCim" type="date" display-format="dd.MM.yyyy" /></div>
                    <div class="ff"><label>Început activitate</label><DxDateBox v-model:value="editForm.DataIncepereActivitate" type="date" display-format="dd.MM.yyyy" /></div>
                    <div class="ff"><label>Încheiere contract</label><DxDateBox v-model:value="editForm.DataIncheiereContract" type="date" display-format="dd.MM.yyyy" /></div>
                </div>

                <hr class="ctr-fline">
                <div class="ctr-seclbl">Normă &amp; salariu</div>
                <div class="ctr-g3">
                    <div class="ff"><label>Normă (ore)</label>
                        <DxSelectBox :data-source="dsTimpMuncaNorma" value-expr="Cod" display-expr="Nume"
                            v-model:value="editForm.TimpMuncaNorma" :search-enabled="true" :show-clear-button="true" />
                    </div>
                    <div class="ff"><label>Salariu brut</label><DxNumberBox v-model:value="editForm.SalariuBrut" /></div>
                    <div class="ff"><label>Spor</label>
                        <DxSelectBox :data-source="sporNames" v-model:value="editForm.SporTipNume"
                            :search-enabled="true" :accept-custom-value="true" :show-clear-button="true"
                            placeholder="[selectați din listă]" />
                    </div>
                </div>

                <hr class="ctr-fline">
                <div class="ctr-seclbl">Observații</div>
                <div class="ff"><DxTextArea v-model:value="editForm.Detalii" :height="70" /></div>
                <div class="ctr-form-actions">
                    <DxButton icon="save" text="Salvează" type="success" styling-mode="contained" @click="salveazaContractForm" />
                    <DxButton v-if="editIsNew" icon="close" text="Renunță" type="normal" styling-mode="outlined" @click="anuleazaContractNou" />
                </div>
            </div>
            <div v-else class="ctr-form-empty">
                <i class="dx-icon dx-icon-doc"></i>
                <p>Selectează un contract din stânga pentru editare<br />sau apasă <b>Adaugă contract</b>.</p>
            </div>
        </div>

        <DxPopupAdd v-model:visible="addPopupVisible" :show-title="true" :height="450" :width="700">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare
                </div>
            </template>
            <DxForm :col-count="2" :form-data="formData" label-alignment="left">
                <DxSimpleItem data-field="NumarContract" :label="{ text: 'Număr contract' }" :is-required="true" />
                <DxSimpleItem data-field="DataConsemnare" editor-type="dxDateBox"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Data consemnare' }" />
                <DxSimpleItem data-field="DataCim" editor-type="dxDateBox"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Data CIM' }" />
                <DxSimpleItem data-field="DataIncepereActivitate" editor-type="dxDateBox"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Început activitate' }" />
                <DxSimpleItem data-field="DataIncheiereContract" editor-type="dxDateBox"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Încheiere contract' }" />
                <DxSimpleItem data-field="CorId" editor-type="dxSelectBox" :label="{ text: 'Funcție (COR)' }"
                    :editor-options="{ dataSource: dsCor, valueExpr: 'Id', displayExpr: corDisplayExpr, searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="TipContract" editor-type="dxSelectBox" :label="{ text: 'Tip contract' }"
                    :editor-options="{ dataSource: dsTipContract, valueExpr: 'Cod', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="TipNorma" editor-type="dxSelectBox" :label="{ text: 'Tip normă' }"
                    :editor-options="{ dataSource: dsTipNorma, valueExpr: 'Cod', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="TimpMuncaNorma" :label="{ text: 'Normă (ore)' }" />
                <DxSimpleItem data-field="SalariuBrut" editor-type="dxNumberBox" :label="{ text: 'Salariu brut' }" />
                <DxSimpleItem data-field="SporTipNume" :label="{ text: 'Spor' }" />
                <DxSimpleItem data-field="TransferInRevisal" editor-type="dxCheckBox" :label="{ text: 'Transfer în Revisal' }" />
                <DxSimpleItem data-field="Detalii" :label="{ text: 'Detalii' }" :col-span="2" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="addButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="closeButtonOptions" />
        </DxPopupAdd>

        <!-- Istoric contracte (versiunile arhivate, EsteIstoric=1) -->
        <DxPopupAdd v-model:visible="istoricPopupVisible" :show-title="true" title="Istoric contracte"
            :height="560" :width="900" :drag-enabled="true" :defer-rendering="false">
            <template #title>
                <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
                    Istoric contracte
                </div>
            </template>
            <DxDataGrid :data-source="dsIstoric" :show-borders="true" :column-auto-width="true" height="100%"
                :no-data-text="'Nu există versiuni istorice.'">
                <DxSorting mode="multiple" />
                <DxColumn data-field="NumarContract" caption="Nr. contract" width="120" />
                <DxColumn data-field="StareCurenta" caption="Stare" width="150" />
                <DxColumn data-field="TipMutare" caption="Tip acțiune" width="130" />
                <DxColumn data-field="DataConsemnare" caption="Consemnare" data-type="date" format="dd.MM.yyyy" width="120" />
                <DxColumn data-field="DataIncepereActivitate" caption="Început" data-type="date" format="dd.MM.yyyy" width="110" />
                <DxColumn data-field="DataIncheiereContract" caption="Încheiere" data-type="date" format="dd.MM.yyyy" width="110" />
                <DxColumn data-field="SalariuBrut" caption="Salariu brut" width="110" />
                <DxColumn data-field="TipContract" caption="Tip contract" width="120" />
                <DxColumn data-field="DataCreare" caption="Creat la" data-type="date" format="dd.MM.yyyy HH:mm" width="140"
                    :sort-index="0" sort-order="desc" />
            </DxDataGrid>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="istoricCloseButtonOptions" />
        </DxPopupAdd>

        <!-- Suspendare contract -->
        <DxPopupAdd v-model:visible="suspendarePopupVisible" :show-title="true" :height="420" :width="640"
            :drag-enabled="true">
            <template #title>
                <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
                    Suspendare contract
                </div>
            </template>
            <DxForm :col-count="2" :form-data="suspendareForm" label-alignment="left">
                <DxSimpleItem data-field="DataInceput" editor-type="dxDateBox" :is-required="true"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Data început' }" />
                <DxSimpleItem data-field="DataSfarsit" editor-type="dxDateBox" :is-required="true"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Data sfârșit' }" />
                <DxSimpleItem data-field="TemeiLegal" :col-span="2" editor-type="dxSelectBox" :label="{ text: 'Temei legal (Revisal)' }"
                    :editor-options="{ dataSource: dsTemeiSuspendare, valueExpr: 'CodRevisal', displayExpr: 'name', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="Explicatie" editor-type="dxTextArea" :col-span="2"
                    :label="{ text: 'Alte detalii' }" :editor-options="{ height: 70 }" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="suspendareSaveButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="suspendareCloseButtonOptions" />
        </DxPopupAdd>

        <!-- Încetare contract -->
        <DxPopupAdd v-model:visible="incetarePopupVisible" :show-title="true" :height="470" :width="660"
            :drag-enabled="true">
            <template #title>
                <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
                    Încetare contract
                </div>
            </template>
            <DxForm :col-count="2" :form-data="incetareForm" label-alignment="left">
                <DxSimpleItem data-field="TipPlecareId" editor-type="dxSelectBox" :col-span="2" :is-required="true"
                    :label="{ text: 'Tip plecare' }"
                    :editor-options="{ dataSource: dsTipuriPlecare, valueExpr: 'Id', displayExpr: 'name', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="DataPlecarii" editor-type="dxDateBox" :is-required="true"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Ultima zi lucrată' }" />
                <DxSimpleItem data-field="DataIncetareContract" editor-type="dxDateBox" :is-required="true"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Data încetare CIM' }" />
                <DxSimpleItem data-field="DecizieNr" :col-span="2" :label="{ text: 'Decizie Nr' }" />
                <DxSimpleItem data-field="Observatii" editor-type="dxTextArea" :col-span="2"
                    :label="{ text: 'Observații' }" :editor-options="{ height: 60 }" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="incetareSaveButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="incetareCloseButtonOptions" />
        </DxPopupAdd>

        <!-- Reactivare contract -->
        <DxPopupAdd v-model:visible="reactivarePopupVisible" :show-title="true" :height="380" :width="620"
            :drag-enabled="true">
            <template #title>
                <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
                    Reactivare contract
                </div>
            </template>
            <DxForm :col-count="2" :form-data="reactivareForm" label-alignment="left">
                <DxSimpleItem data-field="DataReactivare" editor-type="dxDateBox" :is-required="true"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Data reactivare' }" />
                <DxSimpleItem data-field="TemeiLegal" editor-type="dxSelectBox" :label="{ text: 'Temei legal (Revisal)' }"
                    :editor-options="{ dataSource: dsTemeiReactivare, valueExpr: 'CodRevisal', displayExpr: 'name', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="Explicatie" editor-type="dxTextArea" :col-span="2"
                    :label="{ text: 'Alte detalii' }" :editor-options="{ height: 60 }" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="reactivareSaveButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="reactivareCloseButtonOptions" />
        </DxPopupAdd>

        <!-- Detașare contract -->
        <DxPopupAdd v-model:visible="detasarePopupVisible" :show-title="true" :height="470" :width="660"
            :drag-enabled="true">
            <template #title>
                <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
                    Detașare contract
                </div>
            </template>
            <DxForm :col-count="2" :form-data="detasareForm" label-alignment="left">
                <DxSimpleItem data-field="AngajatorNume" :col-span="2" :is-required="true"
                    :label="{ text: 'Denumire angajator destinație' }" />
                <DxSimpleItem data-field="AngajatorCui" :is-required="true" :label="{ text: 'CUI angajator destinație' }" />
                <DxSimpleItem data-field="Tara" :label="{ text: 'Țara' }" :editor-options="{ placeholder: 'România' }" />
                <DxSimpleItem data-field="DataInceput" editor-type="dxDateBox" :is-required="true"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Data început' }" />
                <DxSimpleItem data-field="DataSfarsit" editor-type="dxDateBox" :is-required="true"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Data sfârșit' }" />
                <DxSimpleItem data-field="Explicatie" editor-type="dxTextArea" :col-span="2"
                    :label="{ text: 'Observații' }" :editor-options="{ height: 60 }" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="detasareSaveButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="detasareCloseButtonOptions" />
        </DxPopupAdd>

        <!-- Schimbare loc muncă -->
        <DxPopupAdd v-model:visible="schimbLocPopupVisible" :show-title="true" :height="440" :width="660"
            :drag-enabled="true">
            <template #title>
                <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
                    Schimbare loc muncă
                </div>
            </template>
            <DxForm :col-count="2" :form-data="schimbLocForm" label-alignment="left">
                <DxSimpleItem data-field="StructuraDestinatieId" editor-type="dxSelectBox" :col-span="2" :is-required="true"
                    :label="{ text: 'Punct de lucru destinație' }"
                    :editor-options="{ dataSource: dsStructuraDest, valueExpr: 'Id', displayExpr: structDisplayExpr, searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="ActAditional" :is-required="true" :label="{ text: 'Act adițional' }" />
                <DxSimpleItem data-field="ActAditionalData" editor-type="dxDateBox"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Data act adițional' }" />
                <DxSimpleItem data-field="DataProduceEfecte" editor-type="dxDateBox" :is-required="true"
                    :editor-options="{ displayFormat: 'dd.MM.yyyy', type: 'date' }" :label="{ text: 'Produce efecte cu' }" />
                <DxSimpleItem data-field="Observatii" editor-type="dxTextArea" :col-span="2"
                    :label="{ text: 'Observații' }" :editor-options="{ height: 60 }" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="schimbLocSaveButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="schimbLocCloseButtonOptions" />
        </DxPopupAdd>

        <!-- L153 — fișă încadrare Legea 153 -->
        <DxPopupAdd v-model:visible="l153PopupVisible" :show-title="true" :height="600" :width="820"
            :drag-enabled="true">
            <template #title>
                <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
                    Încadrare L153 (Legea 153) — {{ l153AngajatNume }}
                </div>
            </template>
            <DxForm :col-count="2" :form-data="l153Form" label-alignment="left">
                <DxSimpleItem data-field="TipRaportId" editor-type="dxSelectBox" :label="{ text: 'Tip raport' }"
                    :editor-options="{ dataSource: l153Nom.TipRaport, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="FunctieId" editor-type="dxSelectBox" :label="{ text: 'Funcție' }"
                    :editor-options="{ dataSource: l153Nom.Functii, valueExpr: 'ID', displayExpr: l153FunctieDisplay, searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="AltaFunctie" :label="{ text: 'Altă funcție' }" />
                <DxSimpleItem data-field="ExplicatiFunctie" :label="{ text: 'Explicație funcție' }" />
                <DxSimpleItem data-field="StudiiId" editor-type="dxSelectBox" :label="{ text: 'Studii' }"
                    :editor-options="{ dataSource: l153Nom.Studii, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="GradId" editor-type="dxSelectBox" :label="{ text: 'Grad' }"
                    :editor-options="{ dataSource: l153Nom.Grad, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="Gradatie" :label="{ text: 'Gradație' }" />
                <DxSimpleItem data-field="Vechime" :label="{ text: 'Vechime' }" />
                <DxSimpleItem data-field="Norma" editor-type="dxSelectBox" :label="{ text: 'Normă' }"
                    :editor-options="{ dataSource: l153Norme, valueExpr: 'Cod', displayExpr: 'Nume', showClearButton: true }" />
                <DxSimpleItem data-field="SpecialitateFunctieId" editor-type="dxSelectBox" :label="{ text: 'Specialitate funcție' }"
                    :editor-options="{ dataSource: l153Nom.SpecialitateFunctie, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="StructuraId" editor-type="dxSelectBox" :label="{ text: 'Structură aprobată' }"
                    :editor-options="{ dataSource: l153Nom.Structura, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="StructuraGardaId" editor-type="dxSelectBox" :label="{ text: 'Specialitate structură gardă' }"
                    :editor-options="{ dataSource: l153Nom.StructuraGarda, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }" />
                <DxSimpleItem data-field="SalariuBaza" :label="{ text: 'Salariu bază' }" />
                <DxSimpleItem data-field="SalariuBrut" :label="{ text: 'Salariu brut' }" />
                <DxSimpleItem data-field="NormeSal" :label="{ text: 'Norme salariale' }" />
                <DxSimpleItem data-field="Valuta" :label="{ text: 'Valută' }" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="l153SaveButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="l153CloseButtonOptions" />
        </DxPopupAdd>
    </div>
</template>
<script lang="ts">
import { DxScrollView } from 'devextreme-vue/scroll-view';
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem,
    DxItem as DxFormItem,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxSearchPanel,
    DxScrolling,
    DxColumnFixing,
    DxColumnChooser,
    DxLookup
} from 'devextreme-vue/data-grid';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxTextBox from 'devextreme-vue/text-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxSelectBox from 'devextreme-vue/select-box';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import { defineComponent, ref, markRaw } from 'vue';
import DataSource from 'devextreme/data/data_source';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem, DxGroupItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import DxPopupView from 'devextreme-vue/popup'
import { DxToolbarItem } from 'devextreme-vue/popup';


export default defineComponent({
    components: {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxValidationRule,
        DxRequiredRule,
        DxItem,
        DxButton,
        DxSearchPanel,
        DxForm,
        DxPopupAdd,
        DxSimpleItem,
        DxGroupItem,
        DxTextBox,
        DxDateBox,
        DxNumberBox,
        DxSelectBox,
        DxTextArea,
        DxCheckBox,
        DxToolbarItem,
        DxPopup,
        DxFormGrid,
        DxFormItem,
        DxScrolling,
        DxColumnFixing,
        DxScrollView,
        DxPopupView,
        DxLookup,
        DxColumnChooser
    },
    props: {
        employeeId: { type: String, required: true },
        employeeRow: { type: Object, default: null }
    },
    computed: {
        isStandalone(): boolean {
            return this.$route?.name === 'Contracte';
        }
    },
    watch: {
        employeeId: {
            immediate: true,
            handler(id) {
                if (!id || !this.$refs.dataGridRef?.instance) return;
                const ds = this.$refs.dataGridRef.instance.getDataSource();
                // Doar contractele curente; versiunile istorice (corectii/suspendari) se vad prin "Istoric".
                ds.filter([["AngajatId", "=", id], "and", ["EsteIstoric", "=", false]]);
                ds.load();
            }
        }
    },
    data() {
        return {
            isDetailsVisible: false,
            editForm: {} as any,
            editIsNew: false,
            dsContracteMunca: {} as DataSource,
            dsCor: markRaw(new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + "RU_COR",
                    key: "Id",
                    fieldTypes: { Id: "Guid" },
                    beforeSend: e => {
                        e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
                    }
                }),
                // RU_COR are ~21.000 randuri (coduri COR) -> paginare + cautare pe server (nu incarca tot)
                paginate: true,
                pageSize: 50,
                searchExpr: ['Cod', 'Nume'],
                searchOperation: 'contains',
            })) as any,
            corDisplayExpr(item: any) {
                if (!item) return '';
                return item.Cod ? `${item.Cod} - ${item.Nume ?? ''}` : (item.Nume ?? '');
            },
            dsTipContract: markRaw(new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'RU_ContracteDeMuncaTipuriContracte',
                    key: 'Cod',
                    beforeSend: e => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; }
                }),
                paginate: false,
                sort: [{ selector: 'Nume', desc: false }]
            })) as any,
            dsTipNorma: markRaw(new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'RU_ContracteDeMuncaTipuriNorme',
                    key: 'Cod',
                    beforeSend: e => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; }
                }),
                paginate: false,
                sort: [{ selector: 'Nume', desc: false }]
            })) as any,
            dsTimpMuncaNorma: markRaw(new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'RU_ContracteDeMuncaTimpMuncaNorme',
                    key: 'Cod',
                    beforeSend: e => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; }
                }),
                paginate: false,
                sort: [{ selector: 'Nume', desc: false }]
            })) as any,
            // Sporuri predefinite (Cod == Nume) — portate 1:1 din legacy RU_DetaliiContract; sporurile de tip
            // "angajator" se introduc liber (acceptCustomValue pe SelectBox)
            sporNames: [
                'Gradatie de merit', 'Indemnizatie ambarcare', 'Indemnizatie comisie expertiza',
                'Indemnizatie conducere', 'Indemnizatie de cifru', 'Indemnizatie de comanda',
                'Indemnizatie de dirigentie', 'Indemnizatie de dispozitiv', 'Indemnizatie misiune permanenta',
                'Indemnizatie presedinte comisie bac', 'Indemnizatie responsabilitati suplimentare sanatate',
                'Indemnizatie titluri clasificare in specialitate', 'Prima de clasificare', 'Prima de parasutare',
                'Prima orara de zbor', 'Salariu de merit', 'Spor de adancime', 'Spor de antena',
                'Spor de aprovizionare', 'Spor de conducator de formatie', 'Spor de confidentialitate',
                'Spor de ecran', 'Spor de fidelitate', 'Spor de frontiera', 'Spor de inaltime', 'Spor de izolare',
                'Spor de noapte', 'Spor de periclitate maxima', 'Spor de preventie', 'Spor de santier',
                'Spor de stabilitate', 'Spor de mobilitate', 'Spor de vechime in munca', 'Spor de week-end',
                'Spor de zbor', 'Spor grefieri', 'Spor imersiune', 'Spor ore suplimentare',
                'Spor pentru activitate de importanta nationala',
                'Spor pentru activitate desfasurata de nevazatori',
                'Spor pentru activitate desfasurata in mediul rural',
                'Spor pentru activitate in conditii de radiatii', 'Spor pentru activitati cu incordare psihica',
                'Spor pentru activitati de prevenire a coruptiei',
                'Spor pentru conditii de lucru in subteran si pe platforma',
                'Spor pentru conditii deosebit de periculoase', 'Spor pentru conditii exceptionale',
                'Spor pentru conditii grele', 'Spor pentru conditii nocive', 'Spor pentru conditii penibile',
                'Spor pentru conditii periculoase', 'Spor pentru conditii stresante', 'Spor pentru conditii toxice',
                'Spor pentru conditii vatamatoare', 'Spor pentru exercitarea unei functii suplimentare',
                'Spor pentru folosirea unei limbi straine', 'Spor pentru garzi efectuate in zile nelucratoare',
                'Spor pentru garzi in afara normei', 'Spor pentru gestionare marfuri',
                'Spor pentru lucrari de exceptie si misiuni speciale', 'Spor pentru misiune permanenta',
                'Spor pentru periculozitate', 'Spor pentru practica pedagogica (in afara invatamantului)',
                'Spor pentru practica pedagogica (in invatamant)', 'Spor pentru program prelungit',
                'Spor pentru risc si suprasolicitare neuropsihica',
                'Spor pentru titlul stiintific de doctor sau doctor docent',
                'Spor pentru unitati sanitare cu specific deosebit'
            ] as string[],
            dataGridRef: ref<DxDataGrid | null>(null),
            addPopupVisible: false,
            editPopupVisible: false,
            istoricPopupVisible: false,
            dsIstoric: null as any,
            suspendarePopupVisible: false,
            suspendareContractId: null as string | null,
            suspendareForm: {
                DataInceput: null as Date | null,
                DataSfarsit: null as Date | null,
                TemeiLegal: 'Art54',
                Explicatie: 'Suspendare'
            },
            incetarePopupVisible: false,
            incetareContractId: null as string | null,
            incetareForm: {
                TipPlecareId: null as string | null,
                DataPlecarii: null as Date | null,
                DataIncetareContract: null as Date | null,
                DecizieNr: '',
                Observatii: 'Plecare'
            },
            reactivarePopupVisible: false,
            reactivareContractId: null as string | null,
            reactivareForm: {
                DataReactivare: null as Date | null,
                TemeiLegal: 'Reintegrare',
                Explicatie: 'Reactivare'
            },
            detasarePopupVisible: false,
            detasareContractId: null as string | null,
            detasareForm: {
                AngajatorNume: '',
                AngajatorCui: '',
                Tara: 'România',
                DataInceput: null as Date | null,
                DataSfarsit: null as Date | null,
                Explicatie: 'Detasare'
            },
            schimbLocPopupVisible: false,
            schimbLocContractId: null as string | null,
            schimbLocForm: {
                StructuraDestinatieId: null as string | null,
                ActAditional: '',
                ActAditionalData: null as Date | null,
                DataProduceEfecte: null as Date | null,
                Observatii: ''
            },
            dsStructuraDest: markRaw(new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'ERP_StructuraCompanie',
                    key: 'Id',
                    fieldTypes: { Id: 'Guid' },
                    beforeSend: e => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; }
                }),
                paginate: true,
                pageSize: 50,
                searchExpr: ['Nume', 'Descr'],
                sort: [{ selector: 'Nume', desc: false }]
            })) as any,
            structDisplayExpr(item: any) {
                if (!item) return '';
                return item.Descr ? `${item.Descr} - ${item.Nume ?? ''}` : (item.Nume ?? '');
            },
            l153PopupVisible: false,
            l153ContractId: null as string | null,
            l153AngajatNume: '',
            l153Nom: { TipRaport: [], Functii: [], Studii: [], Grad: [], SpecialitateFunctie: [], Structura: [], StructuraGarda: [] } as any,
            l153Norme: [
                { Cod: '1', Nume: 'normă întreagă 5/25' },
                { Cod: '2', Nume: 'normă întreagă 6/30' },
                { Cod: '3', Nume: 'normă întreagă 8/40' },
                { Cod: '4', Nume: 'normă întreagă 7/35' },
                { Cod: '5', Nume: 'normă întreagă - alte opțiuni' },
                { Cod: '6', Nume: 'timp parțial - alte opțiuni' },
                { Cod: '7', Nume: 'conform grafic gărzi' }
            ],
            l153FunctieDisplay(item: any) {
                if (!item) return '';
                return item.Cod ? `${item.Cod} - ${item.Nume ?? ''}` : (item.Nume ?? '');
            },
            l153Form: {} as any,
            dsTipuriPlecare: markRaw(new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'PER_EmploymentTypes',
                    key: 'Id',
                    fieldTypes: { Id: 'Guid' },
                    beforeSend: e => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; }
                }),
                filter: ['inOut', '=', 'O'],
                sort: [{ selector: 'name', desc: false }],
                paginate: false
            })) as any,
            dsTemeiSuspendare: markRaw(new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'PER_EmploymentTypes',
                    key: 'Id',
                    fieldTypes: { Id: 'Guid' },
                    beforeSend: e => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; }
                }),
                filter: ['inOut', '=', 'S'],
                sort: [{ selector: 'name', desc: false }],
                paginate: false
            })) as any,
            dsTemeiReactivare: markRaw(new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'PER_EmploymentTypes',
                    key: 'Id',
                    fieldTypes: { Id: 'Guid' },
                    beforeSend: e => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; }
                }),
                filter: ['inOut', '=', 'R'],
                sort: [{ selector: 'name', desc: false }],
                paginate: false
            })) as any,
            selectContracte: {} as any,
            formData: {
                Id: null,
                AngajatId: null,
                NumarContract: null,
                TipContract: null,
                DataIncepereActivitate: null,
                DataIncheiereContract: null,
                TipNorma: null,
                SalariuBrut: null,
                CorId: null,
                DataCim: null,
                DataConsemnare: null,
                Detalii: null,
                ExceptieDataSfarsit: null,
                NumereContractVechi: null,
                Radiat: null,
                SporTipNume: null,
                StareCurentaId: null,
                TimpMuncaDurata: null,
                TimpMuncaIntervalTimp: null,
                CorVersiune: null,
                StareCurenta: null,
                TimpMuncaNorma: null,
                TimpMuncaRepartizare: null,
                AngajatorSursaCui: null,
                AngajatorSursaDenumire: null,
                DataImport: null,
                TipMutare: null,
                DataReactivare: null,
                TipDurata: null,
                TransferInRevisal: false,
                EchipamentIndividualProtectie: null,
                EchipamentIndividualLucru: null,
                MaterialeIgienicoSanitare: null,
                AlimentatieProtectie: null,
                AlteDrepturiObligatiiSsm: null,
                NumarContractColectivMunca: null,
                DataIncheiereContractColectiv: null,
                SeriePermisMunca: null,
                NumarPermisMunca: null,
                DataPermisMunca: null,
                NrLuniActivitate: null,
                LocatiaDesfasurariiActivitatii: null,
                ConcediuOdihnaSuplimentar: null,
                DataPlataSalariu: null,
                PerioadaProba: null,
                TipPreaviz: null,
                PerioadaPreaviz: null,
                EsteIstoric: false,
                DetaliiMutare: null,
                SporIsProcent: null,
                SporTip: null,
                SporTipVersiune: null,
                SporValoare: null,
                UserCreare: null,
                DataCreare: null,
                UserModificare: null,
                DataModificare: null,
                ContractReferintaId: null,
                EmploymentTypeId: null,
                AaNr: null,
                AaData: null,
                AaValabilDeLa: null,
                AaValabilPanaLa: null,
                DateContractVechi: null
            },
            addButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveAdd()
                }
            },
            saveButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveEdit()
                }
            },
            closeButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.onCloseAdd()
                }
            },
            istoricCloseButtonOptions: {
                type: "normal",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.closeIstoric()
                }
            },
            suspendareSaveButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.salveazaSuspendare()
                }
            },
            suspendareCloseButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.closeSuspendare()
                }
            },
            incetareSaveButtonOptions: {
                type: "success", text: "Salvează", stylingMode: "contained",
                onClick: () => { this.salveazaIncetare() }
            },
            incetareCloseButtonOptions: {
                type: "danger", text: "Închide", stylingMode: "contained",
                onClick: () => { this.closeIncetare() }
            },
            reactivareSaveButtonOptions: {
                type: "success", text: "Salvează", stylingMode: "contained",
                onClick: () => { this.salveazaReactivare() }
            },
            reactivareCloseButtonOptions: {
                type: "danger", text: "Închide", stylingMode: "contained",
                onClick: () => { this.closeReactivare() }
            },
            detasareSaveButtonOptions: {
                type: "success", text: "Salvează", stylingMode: "contained",
                onClick: () => { this.salveazaDetasare() }
            },
            detasareCloseButtonOptions: {
                type: "danger", text: "Închide", stylingMode: "contained",
                onClick: () => { this.closeDetasare() }
            },
            schimbLocSaveButtonOptions: {
                type: "success", text: "Salvează", stylingMode: "contained",
                onClick: () => { this.salveazaSchimbLoc() }
            },
            schimbLocCloseButtonOptions: {
                type: "danger", text: "Închide", stylingMode: "contained",
                onClick: () => { this.closeSchimbLoc() }
            },
            l153SaveButtonOptions: {
                type: "success", text: "Salvează", stylingMode: "contained",
                onClick: () => { this.salveazaL153() }
            },
            l153CloseButtonOptions: {
                type: "danger", text: "Închide", stylingMode: "contained",
                onClick: () => { this.closeL153() }
            },
            dangerButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.closeEditPopup()
                }
            },
            customTitleTemplate() {
                return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:880px; color: white; 
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
            },
        }
    },

    mounted() {
        this.dsContracteMunca = markRaw(new DataSource({
            store: new ODataStore({
                version: 4,
                url: AppSetting.API_Url_ResurseUmaneOdata + "RU_ContracteDeMunca",
                key: "Id",
                fieldTypes: { Id: "Guid", AngajatId: "Guid" },
                beforeSend: e => {
                    e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
                }
            }),
            // setez filtrul inițial aici — doar contractele curente (ca in legacy: EsteIstoric=0)
            filter: [["AngajatId", "=", this.employeeId], "and", ["EsteIstoric", "=", false]]
        }));
        // preîncarc nomenclatoarele mici (statice) ca dropdown-urile din formular să fie instant la deschidere
        if (this.isStandalone) {
            (this.dsTipContract as any)?.load?.();
            (this.dsTipNorma as any)?.load?.();
            (this.dsTimpMuncaNorma as any)?.load?.();
        }
    },
    methods: {
        onRowDblClick(e: any) {
            if (this.isStandalone) return; // pe pagina separata editarea se face din formular
            if (e?.rowType === 'data' && e?.component) e.component.editRow(e.rowIndex);
        },
        stareLabel(v: string) {
            const map: Record<string, string> = {
                ContractStareActiv: 'Activ', ContractStareSuspendare: 'Suspendat',
                ContractStareDetasare: 'Detașat', ContractStareIncetare: 'Încetat',
                ContractStareReactivare: 'Reactivat', ContractStareMutare: 'Mutat'
            };
            return map[v] ?? (v || '—');
        },
        stareClass(v: string) {
            const map: Record<string, string> = {
                ContractStareActiv: 'chip-activ', ContractStareSuspendare: 'chip-susp',
                ContractStareDetasare: 'chip-det', ContractStareIncetare: 'chip-incetat',
                ContractStareReactivare: 'chip-react', ContractStareMutare: 'chip-mutat'
            };
            return map[v] ?? 'chip-default';
        },
        onViewDetails(e) {
            const rowData = e?.row?.data;
            if (rowData) {
                this.showDetails(rowData);
            }
        },
        showDetails(contracte: any) {

            this.selectContracte = {
                ...contracte,

            };
            this.isDetailsVisible = true;
        },
        closeEditPopup() {
            (this.$refs.dataGridRef as any)?.instance?.cancelEditData();
        },
        onAddClick() {
            if (this.isStandalone) { this.addNouContract(); return; }
            this.addPopupVisible = true
        },
        // --- Master-detail (pagina standalone) ---
        onContractSelected(e: any) {
            if (!this.isStandalone) return;
            const row = e.selectedRowsData?.[0];
            if (!row) return;
            this.editIsNew = false;
            this.editForm = { ...row };
        },
        addNouContract() {
            this.editIsNew = true;
            this.editForm = {
                Id: crypto.randomUUID(),
                AngajatId: this.employeeId,
                NumarContract: null, CorId: null, DataConsemnare: null, DataCim: null,
                DataIncepereActivitate: null, DataIncheiereContract: null, TipContract: null,
                TipNorma: null, TimpMuncaNorma: null, SalariuBrut: null, SporTipNume: null,
                TransferInRevisal: false, Detalii: null, EsteIstoric: false
            };
            (this.$refs.dataGridRef as any)?.instance?.clearSelection?.();
        },
        anuleazaContractNou() {
            this.editIsNew = false;
            this.editForm = {};
        },
        async salveazaContractForm() {
            if (!this.editForm?.NumarContract) { notify('Completați „Număr contract".', 'error', 2500); return; }
            const store = (this.dsContracteMunca as DataSource).store();
            const camp = ['NumarContract', 'CorId', 'DataConsemnare', 'DataCim', 'DataIncepereActivitate',
                'DataIncheiereContract', 'TipContract', 'TipNorma', 'TimpMuncaNorma', 'SalariuBrut',
                'SporTipNume', 'TransferInRevisal', 'Detalii'];
            const payload: any = {};
            for (const k of camp) payload[k] = this.editForm[k] === '' ? null : this.editForm[k];
            try {
                if (this.editIsNew) {
                    await store.insert({ ...payload, Id: this.editForm.Id, AngajatId: this.employeeId, EsteIstoric: false });
                    notify('Contract adăugat.', 'success', 2000);
                } else {
                    await store.update(this.editForm.Id, payload);
                    notify('Contract salvat.', 'success', 2000);
                }
                this.editIsNew = false;
                (this.$refs.dataGridRef as any)?.instance?.refresh();
            } catch (err: any) {
                notify(err?.message || 'Eroare la salvare.', 'error', 4000);
            }
        },
        async onSaveEdit() {
            const gridInstance = (this.$refs.dataGridRef as any)?.instance;
            if (!gridInstance) {
                notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                return;
            }
            try {
                await gridInstance.saveEditData()
                notify('Datele au fost salvate cu succes!', 'success', 2000);
            } catch (error: any) {
                console.error("Eroare la salvarea editării:", error);
                notify('Eroare la salvarea editării!', 'error', 2000);
            }
        },
        onSaveAdd() {
            if (!this.formData.NumarContract) {
                notify('Completați câmpul obligatoriu "Număr Contract"!', 'error', 2000)
                return
            }
            const payload: any = { ...this.formData, Id: crypto.randomUUID(), AngajatId: this.employeeId };
            Object.keys(payload).forEach(k => { if (payload[k] === '') payload[k] = null; });
            const store = (this.dsContracteMunca as DataSource).store();
            store.insert(payload).then(() => {
                this.addPopupVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 2000);
                (this.$refs.dataGridRef as any)?.instance?.refresh();
            }).catch((error: any) => {
                console.error(error);
                notify('Eroare la salvarea datelor!', 'error', 2000);
            })
        },
        onCloseAdd() {
            this.addPopupVisible = false;
        },
        goToContracts() {
            // salvam angajatul ca sa-l reselectam in grid la intoarcere (tab-ul e salvat de PER_EmployeesDetails)
            localStorage.setItem('ru_personal_empId', this.employeeId);
            localStorage.setItem('ru_personal_restore', '1');
            this.$router.push({
                name: 'Contracte',
                params: { id: this.employeeId }
            });
        },
         goBack() {
            this.$router.back()
            this.$emit('back')
        },
        // Sub-actiuni contract (legacy: Corectie/Suspendare/Detasare/Schimb loc munca/
        // Incetare-Reactivare/Istoric/L153). Deocamdata stub: cer contractul selectat.
        onSubAction(actiune: string) {
            const grid: any = (this.$refs.dataGridRef as any)?.instance;
            const sel = grid?.getSelectedRowsData?.() ?? [];
            if (actiune !== 'l153' && actiune !== 'istoric' && sel.length === 0) {
                notify('Selectați întâi un contract.', 'warning', 2500);
                return;
            }
            if (actiune === 'istoric') {
                this.openIstoric();
                return;
            }
            if (actiune === 'suspendare') {
                this.openSuspendare(sel[0]);
                return;
            }
            if (actiune === 'incetareReactivare') {
                // Reactivare doar din starea „Încetare"; altfel Încetare (ca validarea din legacy).
                if (sel[0]?.StareCurenta === 'ContractStareIncetare') this.openReactivare(sel[0]);
                else this.openIncetare(sel[0]);
                return;
            }
            if (actiune === 'detasare') {
                this.openDetasare(sel[0]);
                return;
            }
            if (actiune === 'corectie') {
                this.corectieContract(sel[0]);
                return;
            }
            if (actiune === 'schimbLocMunca') {
                this.openSchimbLoc(sel[0]);
                return;
            }
            if (actiune === 'l153') {
                this.openL153(sel[0]);
                return;
            }
            notify(`Acțiunea „${actiune}" va fi implementată.`, 'info', 2500);
        },
        async openL153(contract: any) {
            this.l153ContractId = contract?.Id ?? null;
            this.l153AngajatNume = this.empName || '';
            const base = AppSetting.API_Url_ResurseUmane;
            const hdr = { 'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt') };
            try {
                const [nomRes, fisaRes] = await Promise.all([
                    fetch(`${base}ru/l153/nomenclatoare`, { headers: hdr }),
                    fetch(`${base}ru/l153/${contract.Id}`, { headers: hdr })
                ]);
                this.l153Nom = await nomRes.json().catch(() => ({}));
                const fisa = await fisaRes.json().catch(() => null);
                this.l153Form = fisa ? {
                    TipRaportId: fisa.TipRaportID, FunctieId: fisa.FunctieID, AltaFunctie: fisa.AltaFunctie,
                    ExplicatiFunctie: fisa.ExplicatiFunctie, StudiiId: fisa.StudiiID, Gradatie: fisa.Gradatie,
                    GradId: fisa.GradID, AltGrad: fisa.AltGrad, Vechime: fisa.Vechime, Norma: fisa.Norma,
                    SpecialitateFunctieId: fisa.SpecialitateFunctieID, StructuraId: fisa.StructuraID,
                    StructuraGardaId: fisa.Structura_GardaID, SalariuBaza: fisa.SalariuBaza,
                    NormeSal: fisa.NormeSal, SalariuBrut: fisa.SalariuBrut, Valuta: fisa.Valuta
                } : {};
                this.l153PopupVisible = true;
            } catch (e: any) {
                notify(e?.message || 'Eroare la încărcarea fișei L153.', 'error', 4000);
            }
        },
        closeL153() { this.l153PopupVisible = false; },
        async salveazaL153() {
            if (!this.l153ContractId) { notify('Selectați un contract.', 'warning', 2500); return; }
            const grid: any = (this.$refs.dataGridRef as any)?.instance;
            const sel = grid?.getSelectedRowsData?.() ?? [];
            const body = { ...this.l153Form, ContractId: this.l153ContractId, AngajatId: sel[0]?.AngajatId ?? null };
            try {
                const res = await fetch(`${AppSetting.API_Url_ResurseUmane}ru/l153`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt') },
                    body: JSON.stringify(body)
                });
                if (!res.ok) {
                    const err = await res.json().catch(() => ({ message: 'Eroare.' }));
                    notify(err.message || 'Eroare.', 'error', 4000);
                    return;
                }
                notify('Fișa L153 a fost salvată.', 'success', 2500);
                this.l153PopupVisible = false;
            } catch (e: any) {
                notify(e?.message || 'Eroare de rețea.', 'error', 4000);
            }
        },
        openSchimbLoc(contract: any) {
            this.schimbLocContractId = contract?.Id ?? null;
            this.schimbLocForm = {
                StructuraDestinatieId: null, ActAditional: '', ActAditionalData: new Date(),
                DataProduceEfecte: new Date(), Observatii: ''
            };
            this.schimbLocPopupVisible = true;
        },
        closeSchimbLoc() { this.schimbLocPopupVisible = false; },
        async salveazaSchimbLoc() {
            const f = this.schimbLocForm;
            if (!this.schimbLocContractId) { notify('Selectați un contract.', 'warning', 2500); return; }
            if (!f.StructuraDestinatieId) { notify('Alegeți punctul de lucru destinație.', 'error', 2500); return; }
            if (!f.ActAditional) { notify('Completați actul adițional.', 'error', 2500); return; }
            if (!f.DataProduceEfecte) { notify('Completați data la care produce efecte.', 'error', 2500); return; }
            const iso = (d: Date | null) => { if (!d) return null; const p = (n: number) => String(n).padStart(2, '0'); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`; };
            await this.postStare('schimbare-loc-munca', {
                ContractId: this.schimbLocContractId,
                StructuraDestinatieId: f.StructuraDestinatieId,
                ActAditional: f.ActAditional,
                ActAditionalData: iso(f.ActAditionalData),
                DataProduceEfecte: iso(f.DataProduceEfecte),
                Observatii: f.Observatii
            }, 'Cererea de schimbare loc muncă a fost înregistrată.', () => { this.schimbLocPopupVisible = false; });
        },
        // Corecție: arhivează versiunea curentă în istoric, apoi deschide editarea rândului.
        async corectieContract(contract: any) {
            const grid: any = (this.$refs.dataGridRef as any)?.instance;
            try {
                const res = await fetch(`${AppSetting.API_Url_ResurseUmane}ru/contracte-stare/corectie/${contract.Id}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt') }
                });
                if (!res.ok) {
                    const err = await res.json().catch(() => ({ message: 'Eroare.' }));
                    notify(err.message || 'Eroare.', 'error', 4000);
                    return;
                }
                notify('Versiunea anterioară a fost arhivată. Puteți edita contractul.', 'info', 2500);
                const idx = grid?.getRowIndexByKey?.(contract.Id);
                if (idx != null && idx >= 0) grid.editRow(idx);
            } catch (e: any) {
                notify(e?.message || 'Eroare de rețea.', 'error', 4000);
            }
        },
        openDetasare(contract: any) {
            this.detasareContractId = contract?.Id ?? null;
            this.detasareForm = {
                AngajatorNume: '', AngajatorCui: '', Tara: 'România',
                DataInceput: new Date(), DataSfarsit: null, Explicatie: 'Detasare'
            };
            this.detasarePopupVisible = true;
        },
        closeDetasare() { this.detasarePopupVisible = false; },
        async salveazaDetasare() {
            const f = this.detasareForm;
            if (!this.detasareContractId) { notify('Selectați un contract.', 'warning', 2500); return; }
            if (!f.AngajatorNume || !f.AngajatorCui) { notify('Completați angajatorul destinație (nume + CUI).', 'error', 2500); return; }
            if (!f.DataInceput || !f.DataSfarsit) { notify('Completați datele.', 'error', 2500); return; }
            const iso = (d: Date) => { const p = (n: number) => String(n).padStart(2, '0'); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`; };
            await this.postStare('detasare', {
                ContractId: this.detasareContractId,
                DataInceput: iso(f.DataInceput),
                DataSfarsit: iso(f.DataSfarsit),
                AngajatorNume: f.AngajatorNume,
                AngajatorCui: f.AngajatorCui,
                Tara: f.Tara,
                Explicatie: f.Explicatie,
                TipActiune: 'Adaugare'
            }, 'Detașare înregistrată.', () => { this.detasarePopupVisible = false; });
        },
        openSuspendare(contract: any) {
            this.suspendareContractId = contract?.Id ?? null;
            this.suspendareForm = {
                DataInceput: new Date(),
                DataSfarsit: null,
                TemeiLegal: 'Art54',
                Explicatie: 'Suspendare'
            };
            this.suspendarePopupVisible = true;
        },
        closeSuspendare() {
            this.suspendarePopupVisible = false;
        },
        openIncetare(contract: any) {
            this.incetareContractId = contract?.Id ?? null;
            this.incetareForm = {
                TipPlecareId: null, DataPlecarii: new Date(), DataIncetareContract: new Date(),
                DecizieNr: '', Observatii: 'Plecare'
            };
            this.incetarePopupVisible = true;
        },
        closeIncetare() { this.incetarePopupVisible = false; },
        async salveazaIncetare() {
            const f = this.incetareForm;
            if (!this.incetareContractId) { notify('Selectați un contract.', 'warning', 2500); return; }
            if (!f.TipPlecareId) { notify('Alegeți tipul de plecare.', 'error', 2500); return; }
            if (!f.DataPlecarii || !f.DataIncetareContract) { notify('Completați datele.', 'error', 2500); return; }
            const iso = (d: Date) => { const p = (n: number) => String(n).padStart(2, '0'); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`; };
            await this.postStare('incetare', {
                ContractId: this.incetareContractId,
                TipPlecareId: f.TipPlecareId,
                DataPlecarii: iso(f.DataPlecarii),
                DataIncetareContract: iso(f.DataIncetareContract),
                DecizieNr: f.DecizieNr,
                Observatii: f.Observatii
            }, 'Încetare înregistrată.', () => { this.incetarePopupVisible = false; });
        },
        openReactivare(contract: any) {
            this.reactivareContractId = contract?.Id ?? null;
            this.reactivareForm = { DataReactivare: new Date(), TemeiLegal: 'Reintegrare', Explicatie: 'Reactivare' };
            this.reactivarePopupVisible = true;
        },
        closeReactivare() { this.reactivarePopupVisible = false; },
        async salveazaReactivare() {
            const f = this.reactivareForm;
            if (!this.reactivareContractId) { notify('Selectați un contract.', 'warning', 2500); return; }
            if (!f.DataReactivare) { notify('Completați data reactivării.', 'error', 2500); return; }
            const iso = (d: Date) => { const p = (n: number) => String(n).padStart(2, '0'); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`; };
            await this.postStare('reactivare', {
                ContractId: this.reactivareContractId,
                DataReactivare: iso(f.DataReactivare),
                TemeiLegal: f.TemeiLegal,
                Explicatie: f.Explicatie,
                TipActiune: 'Adaugare'
            }, 'Reactivare înregistrată.', () => { this.reactivarePopupVisible = false; });
        },
        // Helper comun pentru POST catre endpoint-urile de stare contract.
        async postStare(actiune: string, body: any, successMsg: string, onOk: () => void) {
            try {
                const res = await fetch(`${AppSetting.API_Url_ResurseUmane}ru/contracte-stare/${actiune}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt') },
                    body: JSON.stringify(body)
                });
                if (!res.ok) {
                    const err = await res.json().catch(() => ({ message: 'Eroare.' }));
                    notify(err.message || 'Eroare.', 'error', 4000);
                    return;
                }
                notify(successMsg, 'success', 2500);
                onOk();
                (this.$refs.dataGridRef as any)?.instance?.refresh();
            } catch (e: any) {
                notify(e?.message || 'Eroare de rețea.', 'error', 4000);
            }
        },
        async salveazaSuspendare() {
            const f = this.suspendareForm;
            if (!this.suspendareContractId) { notify('Selectați un contract.', 'warning', 2500); return; }
            if (!f.DataInceput || !f.DataSfarsit) { notify('Completați data de început și de sfârșit.', 'error', 2500); return; }
            const toIso = (d: Date) => {
                const p = (n: number) => String(n).padStart(2, '0');
                return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
            };
            try {
                const res = await fetch(`${AppSetting.API_Url_ResurseUmane}ru/contracte-stare/suspendare`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
                    },
                    body: JSON.stringify({
                        ContractId: this.suspendareContractId,
                        DataInceput: toIso(f.DataInceput),
                        DataSfarsit: toIso(f.DataSfarsit),
                        TemeiLegal: f.TemeiLegal,
                        Explicatie: f.Explicatie,
                        TipActiune: 'Adaugare'
                    })
                });
                if (!res.ok) {
                    const err = await res.json().catch(() => ({ message: 'Eroare la suspendare.' }));
                    notify(err.message || 'Eroare la suspendare.', 'error', 4000);
                    return;
                }
                notify('Suspendare înregistrată.', 'success', 2500);
                this.suspendarePopupVisible = false;
                (this.$refs.dataGridRef as any)?.instance?.refresh();
            } catch (e: any) {
                notify(e?.message || 'Eroare de rețea.', 'error', 4000);
            }
        },
        // Istoric = versiunile arhivate ale contractelor angajatului (EsteIstoric=1). Pur LINQ (OData), read-only.
        openIstoric() {
            this.dsIstoric = markRaw(new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + "RU_ContracteDeMunca",
                    key: "Id",
                    fieldTypes: { Id: "Guid", AngajatId: "Guid" },
                    beforeSend: e => {
                        e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
                    }
                }),
                filter: [["AngajatId", "=", this.employeeId], "and", ["EsteIstoric", "=", true]],
                sort: [{ selector: "DataCreare", desc: true }]
            }));
            this.istoricPopupVisible = true;
        },
        closeIstoric() {
            this.istoricPopupVisible = false;
        },


    },
})
</script>
<style>
.back-button {
    background-color: #f5f5f5 !important;
    color: #1f1e1e !important;
    border: 1px solid #ccc !important;
    border-radius: 6px !important;
    padding: 8px 14px !important;
    margin-right: 8px !important;
    transition: all 0.2s ease-in-out;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.back-button:hover {
    background-color: #f34f26 !important;
    color: #fff !important;
    transform: translateX(-3px);
}

/* Bara de sub-actiuni contract */
.ctr-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}

.ctr-act {
    border-radius: 8px !important;
    transition: all 0.15s ease-in-out;
}

/* accent ERA la hover pe fiecare sub-actiune */
.ctr-act.dx-button:hover {
    border-color: #ff2c21 !important;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a) !important;
}

.ctr-act.dx-button:hover .dx-icon,
.ctr-act.dx-button:hover .dx-button-text {
    color: #fff !important;
}

.ctr-act .dx-icon {
    color: #ff2c21;
}

/* Chip stare contract */
.ctr-chip {
    display: inline-block;
    padding: 3px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}
.chip-activ { background: #ecfdf5; color: #065f46; }
.chip-susp { background: #fef3c7; color: #92400e; }
.chip-det { background: #eff6ff; color: #1d4ed8; }
.chip-incetat { background: #fef2f2; color: #b91c1c; }
.chip-react { background: #f0fdfa; color: #0f766e; }
.chip-mutat { background: #f5f3ff; color: #6d28d9; }
.chip-default { background: #f1f5f9; color: #475569; }

/* Grid contracte (fara overflow:hidden — ar taia scrollbar-ul orizontal) */
.ctr-grid { border-radius: 10px; }

/* Layout master-detail (pagina standalone) */
.ctr-split {
    display: flex; gap: 18px; align-items: flex-start;
    padding: 18px;
    background: linear-gradient(180deg, #f8f9fc, #eef1f6);
    border-radius: 16px;
}
.ctr-split .ctr-gridcol {
    flex: 0 0 330px; min-width: 260px;
    background: #fff; border: 1px solid #e5e7eb; border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0,0,0,.05); overflow: hidden;
}
.ctr-col-head {
    display: flex; align-items: center; gap: 8px;
    padding: 11px 14px; background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff; font-weight: 700; font-size: 13.5px;
}
.ctr-col-head .dx-icon { font-size: 16px; }
.ctr-split .ctr-gridcol .ctr-grid { border-radius: 0; }
.ctr-formcol {
    flex: 1 1 auto;
    max-width: none;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(255,44,33,.06), 0 1px 3px rgba(0,0,0,.08);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.ctr-form-head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
    font-weight: 700;
    font-size: 14px;
}
.ctr-form-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: #f8f9fc;
    border-bottom: 1px solid #eef1f6;
}
.ctr-form-toolbar .ctr-add-btn { margin-left: auto; }
.ctr-form-head.is-new { background: linear-gradient(90deg, #059669, #10b981); }
.ctr-form-head .dx-icon { font-size: 18px; }
.ctr-form-body { padding: 22px 22px 10px; overflow: auto; }
/* Formular plat (varianta A): etichete de sectiune + linii fine */
.ctr-seclbl {
    display: flex; align-items: center; gap: 9px;
    font-size: 11.5px; font-weight: 800; text-transform: uppercase; letter-spacing: .7px;
    color: #ff2c21; margin: 0 0 14px;
}
.ctr-seclbl::before {
    content: ""; width: 4px; height: 15px; border-radius: 3px;
    background: linear-gradient(180deg, #ff2c21, #ff6a4a);
}
.ctr-fline { height: 1px; border: none; background: linear-gradient(90deg, rgba(255,106,74,.35), transparent); margin: 24px 0; }
.ctr-g3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px 18px; }
.ctr-g3 .full { grid-column: 1 / -1; }
.ctr-formcol .ff { display: flex; flex-direction: column; gap: 6px; }
.ctr-formcol .ff > label {
    font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: #94a3b8;
}
@media (max-width: 900px) { .ctr-g3 { grid-template-columns: repeat(2, 1fr); } }

/* Editori DevExtreme — rotunjire + focus ERA */
.ctr-formcol .dx-texteditor { border-radius: 8px; transition: border-color .15s, box-shadow .15s; }
.ctr-formcol .dx-texteditor.dx-editor-filled { background: #f8f9fc; }
.ctr-formcol .dx-texteditor.dx-state-focused,
.ctr-formcol .dx-texteditor.dx-state-active {
    border-color: #ff6a4a !important;
    box-shadow: 0 0 0 3px rgba(255,106,74,.15);
}
.ctr-formcol .dx-texteditor.dx-state-hover { border-color: #ffb4a3; }
/* card formular: umbra putin mai calda */
.ctr-formcol { box-shadow: 0 4px 16px rgba(255,44,33,.06), 0 1px 3px rgba(0,0,0,.08); }
.ctr-form-actions { display: flex; gap: 10px; margin-top: 14px; }
.ctr-form-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #94a3b8;
    text-align: center;
    padding: 30px;
}
.ctr-form-empty .dx-icon { font-size: 42px; opacity: .5; }



/* From Uiverse.io by Nawsome */
.continue-application {
    --color: #fff;
    --background: #ffffff;
    --background-hover: #dfe1eb;
    --background-left: #ffffff;
    --folder: #F3E9CB;
    --folder-inner: #BEB393;
    --paper: #FFFFFF;
    --paper-lines: #BBC1E1;
    --paper-behind: #E1E6F9;
    --pencil-cap: #fff;
    --pencil-top: #fe7627;
    --pencil-middle: #fff;
    --pencil-bottom: #f19914;
    --shadow: rgba(187, 107, 33, 0.2);
    border: none;
    outline: none;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    -webkit-tap-highlight-color: transparent;
    padding: 15px 20px 10px 60px;
    color: #525151;
    background: #fff;
}

.continue-application>div {
    top: 0;
    left: 0;
    bottom: 0;
    width: 53px;
    position: absolute;
    overflow: hidden;
    border-radius: 5px 0 0 5px;
    background: var(--background-left);
}

.continue-application>div .folder {
    width: 23px;
    height: 27px;
    position: absolute;
    left: 15px;
    top: 13px;
}

.continue-application>div .folder .top {
    left: 0;
    top: 0;
    z-index: 2;
    position: absolute;
    transform: translateX(var(--fx, 0));
    transition: transform 0.4s ease var(--fd, 0.3s);
}

.continue-application>div .folder .top svg {
    width: 24px;
    height: 27px;
    display: block;
    fill: var(--folder);
    transform-origin: 0 50%;
    transition: transform 0.3s ease var(--fds, 0.45s);
    transform: perspective(120px) rotateY(var(--fr, 0deg));
}

.continue-application>div .folder:before,
.continue-application>div .folder:after,
.continue-application>div .folder .paper {
    content: "";
    position: absolute;
    left: var(--l, 0);
    top: var(--t, 0);
    width: var(--w, 100%);
    height: var(--h, 100%);
    border-radius: 1px;
    background: var(--b, var(--folder-inner));
}

.continue-application>div .folder:before {
    box-shadow: 0 1.5px 3px var(--shadow), 0 2.5px 5px var(--shadow), 0 3.5px 7px var(--shadow);
    transform: translateX(var(--fx, 0));
    transition: transform 0.4s ease var(--fd, 0.3s);
}

.continue-application>div .folder:after,
.continue-application>div .folder .paper {
    --l: 1px;
    --t: 1px;
    --w: 21px;
    --h: 25px;
    --b: var(--paper-behind);
}

.continue-application>div .folder:after {
    transform: translate(var(--pbx, 0), var(--pby, 0));
    transition: transform 0.4s ease var(--pbd, 0s);
}

.continue-application>div .folder .paper {
    z-index: 1;
    --b: var(--paper);
}

.continue-application>div .folder .paper:before,
.continue-application>div .folder .paper:after {
    content: "";
    width: var(--wp, 14px);
    height: 2px;
    border-radius: 1px;
    transform: scaleY(0.5);
    left: 3px;
    top: var(--tp, 3px);
    position: absolute;
    background: var(--paper-lines);
    box-shadow: 0 12px 0 0 var(--paper-lines), 0 24px 0 0 var(--paper-lines);
}

.continue-application>div .folder .paper:after {
    --tp: 6px;
    --wp: 10px;
}

.continue-application>div .pencil {
    height: 2px;
    width: 3px;
    border-radius: 1px 1px 0 0;
    top: 8px;
    left: 105%;
    position: absolute;
    z-index: 3;
    transform-origin: 50% 19px;
    background: var(--pencil-cap);
    transform: translateX(var(--pex, 0)) rotate(35deg);
    transition: transform 0.4s ease var(--pbd, 0s);
}

.continue-application>div .pencil:before,
.continue-application>div .pencil:after {
    content: "";
    position: absolute;
    display: block;
    background: var(--b, linear-gradient(var(--pencil-top) 55%, var(--pencil-middle) 55.1%, var(--pencil-middle) 60%, var(--pencil-bottom) 60.1%));
    width: var(--w, 5px);
    height: var(--h, 20px);
    border-radius: var(--br, 2px 2px 0 0);
    top: var(--t, 2px);
    left: var(--l, -1px);
}

.continue-application>div .pencil:before {
    -webkit-clip-path: polygon(0 5%, 5px 5%, 5px 17px, 50% 20px, 0 17px);
    clip-path: polygon(0 5%, 5px 5%, 5px 17px, 50% 20px, 0 17px);
}

.continue-application>div .pencil:after {
    --b: none;
    --w: 3px;
    --h: 6px;
    --br: 0 2px 1px 0;
    --t: 3px;
    --l: 3px;
    border-top: 1px solid var(--pencil-top);
    border-right: 1px solid var(--pencil-top);
}

.continue-application:before,
.continue-application:after {
    content: "";
    position: absolute;
    width: 10px;
    height: 2px;
    border-radius: 1px;
    background: var(--color);
    transform-origin: 9px 1px;
    transform: translateX(var(--cx, 0)) scale(0.5) rotate(var(--r, -45deg));
    top: 26px;
    right: 16px;
    transition: transform 0.3s;
}

.continue-application:after {
    --r: 45deg;
}

.continue-application:hover {
    --cx: 2px;
    --bg: var(--background-hover);
    --fx: -40px;
    --fr: -60deg;
    --fd: .15s;
    --fds: 0s;
    --pbx: 3px;
    --pby: -3px;
    --pbd: .15s;
    --pex: -24px;
}

.circle-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle {
    width: 12px;
    height: 12px;
}

.circle-true {
    background-color: #4caf50;
    color: white;
}

.circle-false {
    background-color: #e71010;
}

.activity-details-container {
    padding: 20px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #444;
    margin: 15px 0 10px 0;
    padding-bottom: 5px;
    border-bottom: 1px solid #eee;
}

.activity-info-item {
    display: flex;
    margin: 8px 0;
}

.info-label {
    font-weight: 600;
    color: #555;
    width: 100px;
}

.info-value {
    color: #333;
    flex: 1;
}

.view-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    flex-direction: row;

    .grid {
        .name-template {

            .position {
                font-size: 12px;
                color: var(--texteditor-label-color);
            }
        }

        :deep(.dx-datagrid-header-panel) {
            padding: 0 var(--content-padding);

        }

        :deep(.dx-datagrid-content .dx-row) {
            cursor: pointer;
        }


    }
}

.edit-cell {
    position: relative;

    activity-status {
        position: absolute;
        margin-top: 10px;
        margin-left: 11px;
    }
}
</style>